<template>
  <div class="p_supply_module p_fee_module">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                  <div class="flname">姓名</div>
                  <el-input v-model="listQuery.username" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <!-- <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div> -->
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <!-- 筛选下拉框 -->
    <!-- <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="任务:">
            <el-select v-model="listQuery.bolUserSex" size="small" placeholder="">
              <el-option label="普工采集" value="普工采集"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="采集平台:">
            <el-select v-model="listQuery.pingtai" size="small" placeholder="">
              <el-option label="宁波人才网" value="宁波人才网"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上班地点:">
            <el-input v-model="listQuery.area" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
          <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageCrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box" v-if="checkPermission(['supMember_page_list'],permissionLists)">
        <div class="r_act_box">
          <div class="r_act_left">
            <div class="r_act_item" v-if="checkPermission(['supMember_add'],permissionLists)">
              <el-button size="small" type="primary" @click="addHandle">新增</el-button>
            </div>
            <!-- <div class="r_act_item" v-if="!this.isNull(this.tableData)">
              <el-button size="small" type="primary" @click="exportHandle" :loading="btnLoading">导出</el-button>
            </div> -->
          </div>
        </div>
        <el-table ref="clueTable" class="re_table" :header-cell-style="{background:'#f2f2f2',color: '#909399'}" border v-loading="tableLoading" :highlight-current-row="true" :max-height="tableHeight-100" :data="tableData" style="width:100%">
            <el-table-column align="center" fixed label="序号" width="60px" fit :show-overflow-tooltip="true">
              <template slot-scope="{$index}">
                  <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="姓名" fixed min-width="100px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                    <span>{{row.Username}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="身份证号码" min-width="120px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                    <span>{{row.Stridcard}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="手机号码" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                    <span>{{row.Strmobile}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="邮箱" min-width="110px" fit :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                    <span>{{row.StrEmail}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="120px">
                <template slot-scope="{row}">
                    <el-button v-if="checkPermission(['supMember_edit'],permissionLists)" type="info" size="mini" plain @click="editHandle(row)">编辑</el-button>
                    <el-button v-if="checkPermission(['supMember_dlt'],permissionLists)" type="info" size="mini" plain @click="dltHandle(row)">删除</el-button>
                </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="listQuery.currpage"
              :page-size="listQuery.perpage"
              @size-change="handleSizeChange"
              :page-sizes="[10, 20, 50, 100, 200]"
              layout="total,sizes,prev,pager,next,jumper"
              :total="total"
            ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增编辑人员弹框 -->
    <el-dialog :title="titleName" :visible.sync="setVisible" width="700px" class="res_dialog">
      <el-form :model="memberQuery" :rules="memberRules" ref="memberForm" class="re_dialog_form" label-width="100px">
        <!-- <el-form-item label="施工队:" prop="userTeamNum">
            <el-select v-model="memberQuery.userTeamNum" placeholder="" size="small" filterable @change="teamHandle">
                <el-option v-for="(item,i) in teamList" :key="i+'d'" :label="item.StrConstrteamName" :value="item.GdteamId"></el-option>
            </el-select>
        </el-form-item> -->
        <el-form-item label="姓名:" prop="userName">
            <el-input v-model="memberQuery.userName" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="userTel">
            <el-input v-model="memberQuery.userTel" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="邮箱:" prop="userEmail">
            <el-input v-model="memberQuery.userEmail" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="身份证号码:" prop="stridcard">
            <el-input v-model="memberQuery.stridcard" size="small" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="密码:" prop="userPwd">
            <el-input v-model="memberQuery.userPwd" type="password" prefix-icon="el-icon-lock" show-password size="small" clearable></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="setVisible = false"
            size="small"
            >取消</el-button>
          <el-button
            type="primary" class="com_dialog_btn"
            @click="saveOneHandle" :disabled="isSendSave"
            size="small"
            >确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  // import SupComTabs from "../supplierManage/components/supComTabs.vue"
  export default {
    // components: {
    //     SupComTabs
    // },
    data() {
        var validatePhone = (rule, value, callback) => {
            const phoneReg = /^(11[0-9]|12[0-9]|13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
            // console.log('validatePhone',value)
            if (value.length == 11 && phoneReg.test(value)) {
                //校验通过
                if(this.enterBtnType != 'save'){
                    this.checkHandle(value, (res) => {
                        // console.log('validatePhone',res)
                        if (res) {
                            callback()
                        } else {
                            this.memberQuery.userTel = ''
                            callback()
                        }
                    })
                }else{
                    callback()
                }
            } else {
                callback(new Error('请输入正确的手机号'))
            }
        }
        var validatecard = (rule, value, callback) => {
            if(!this.isNull(value)){
                if (value.length != 18) {
                    callback(new Error('身份证号码格式不正确'));
                } else {
                    let idcode = value;
                    let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,];
                    let check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
                    let code = idcode + "";
                    let last = idcode[17].toUpperCase(); //最后一个
                    let seventeen = code.substring(0, 17);
                    // ISO 7064:1983.MOD 11-2
                    // 判断最后一位校验码是否正确
                    let arr = seventeen.split("");
                    let len = arr.length;
                    let num = 0;
                    for (let i = 0; i < len; i++) {
                    num = num + arr[i] * weight_factor[i];
                    }
                    // 获取余数
                    var resisue = num % 11;
                    var last_no = check_code[resisue];
                    // 格式的正则
                    // 正则思路
                    var idcard_patter = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
                    // 判断格式是否正确
                    var format = idcard_patter.test(idcode);
                    if (last === last_no && format == true) {
                    callback()
                    } else {
                    callback(new Error('身份证号码格式不正确'));
                    }
                }
            }else{
                callback()
            }
        };
      return {
        //禁用日期范围
        pickerOptions: {
            disabledDate(time) {
            return time.getTime() > Date.now();
            }
        },
        enterBtnType:'',
        teamList:[],//施工队列表
        importDialog:false,
        importVisible:false,
        isSendSave:false,
        titleName:'新增人员',
        tableHeight: 0,
        showDropScreen:-1,
        pageCrumb:'人员列表',
        activeName:'third',
        tableData: [],
        listQuery:{
          username:'',// 姓名
          currpage:1,
          perpage:10
        },
        downVisible:false,
        custPath: '',//导出文件下载路径
        isSearchHandle:false,
        tableLoading:false,
        // 表头数据
        tableTitle:[],
        total:0,
        tablePath: this.$store.state.EMP.tablePath,
        fullscreenLoading: false,
        //角色类型
        roleType: '',
        setVisible:false,
        memberQuery:{
            newuserid: '',
            userTel: '',// 手机号
            userName: '',// 姓名
            stridcard: '',// 身份证
            userEmail: '',// 邮箱
            userPwd: ''// 密码（新增默认一个密码 重置密码  需要传） 编辑不用传
        },
        memberRules:{
            userTel: [
                { required: true, message: '请输入手机号码', trigger: 'blur' },
                { validator: validatePhone, trigger: ['blur'] }
            ],
            userName: [
                { required: true, message: '请输入姓名', trigger: 'blur' }
            ],
            userTeamNum: [
                { required: true, message: '请选择施工队', trigger: 'change' }
            ],
            stridcard:[
              { required: true, message: '请输入身份证号码', trigger: 'blur' },
              { message: '请输入正确的身份证号码', validator: validatecard, trigger: ['blur'] }
            ],
            // userPwd: [
            //     { required: true, message: '请输入密码', trigger: 'blur' }
            // ],
            userEmail: [
                { required: true, message: '请输入邮箱', trigger: 'blur' },
                { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
            ]
        },
        dtlQuery:{
            useridr:''
        },
        teamQuery:{
          strConstrteamName:'',// 施工队名称
          strSerStatus:'',// 服务状态 正常/退出
          strExamStatus:'',// 通过/不通过
          strArea:'',//区域
          strCityCompany:'',//城市公司
          currpage:1,
          perpage:1000000
        },
        // 按钮权限参数
        butQuery:{
          path:'/supMember',
          powerEnName:'supplierManage'
        },
        permissionLists:[]
      }
    },
    created() {
      this.calHeight();
      this.roleType = localStorage.loginRoletype
      this.getButtonPower()
    //   this.getTeamList()
    },
    methods: {
      checkPermission,
        // 获取按钮权限
        getButtonPower(){
          let that = this
          xz.getbtnPowerIdBypage(this.butQuery).then(res => {
            // console.log('按钮',res)
            if(res.status == 'ok'){
              let resmsg = res.msg
              if(!this.isNull(resmsg)){
                for (let index = 0; index < resmsg.length; index++) {
                  let element = resmsg[index];
                  this.permissionLists.push(element.Enname);
                }
                if(that.checkPermission(['supMember_page_list'],that.permissionLists)){
                  that.getList()
                }
              }else{
                this.permissionLists = []
              }
            }else{
              this.permissionLists = []
            }
          })
        },
        calHeight() {
            this.tableHeight = Number(document.body.clientHeight);
            // console.log('height', this.tableHeight)
        },
        // 人员详情
        getMemberDtl(id){
            xz.getTeamUserDetail(id).then(res => {
                // console.log('详情', res)
                if (res.status == 'ok') {
                  let lastSix = res.msg.Stridcard.substring(12,18)
                    this.memberQuery = {
                        newuserid: res.msg.Userid,
                        userTel: res.msg.Strmobile,// 手机号
                        userName: res.msg.Username,// 姓名
                        stridcard: res.msg.Stridcard,// 身份证
                        userEmail: res.msg.StrEmail,// 邮箱
                        userPwd: lastSix+'!'// 密码（新增默认一个密码 重置密码  需要传） 编辑不用传
                    }
                }
            })
        },
        // 验证手机号
        checkHandle(chkval, callback){
            if (chkval.length > 0) {
                xz.checkJbTeamUser(chkval,this.memberQuery.newuserid).then(res => {
                    // console.log('checkHandle', res)
                    if (res.status == 'ok') {
                        callback(true)
                    }else{
                        this.$message({ type: 'warning', message: res.msg })
                        callback(false)
                    }
                })
            }
        },
        // 保存人员
        saveOneHandle(){
          let that = this
            this.enterBtnType = 'save'
            this.isSendSave = true
            let lastSix = that.memberQuery.stridcard.substring(12,18)
            this.memberQuery.userPwd = lastSix + '!'
            this.$refs['memberForm'].validate((valid) => {
                if (valid) {
                    // console.log('saveEnterHandle', this.memberQuery)
                    xz.saveJbTeamUserInfo(this.memberQuery).then(res => {
                        // console.log('saveEnterHandle', res)
                        if (res.status == 'ok') {
                            this.$message({ type: 'success', message: '操作成功' })
                            this.getList()
                            this.setVisible = false
                        }else{
                            this.$message({ type: 'error', message: res.msg })
                        }
                        this.isSendSave = false
                    })
                }else {
                    return false;
                }
            })
        },
        // 删除人员
        dltHandle(item){
          let that = this
            this.$confirm('是否确定删除此数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async() => {
                xz.delJbTeamUser(item.Userid).then(res => {
                    // console.log('getList', res)
                    if (res.status == 'ok') {
                      this.getList()
                      that.$message.success('操作成功')
                    } else {
                      that.$message.success(res.msg)
                    }
                })
            }).catch(err => { console.error(err) })
        },
        // 编辑人员
        editHandle(item){
            this.titleName = '编辑人员'
            // console.log('item', item)
            this.dtlQuery.useridr = item.Userid
            this.getMemberDtl(item.Userid)
            this.setVisible = true
        },
        // 新增人员弹框
        addHandle(){
            let that = this
            this.enterBtnType = ''
            this.titleName = '新增人员'
            this.memberQuery = this.$options.data.call(this).memberQuery
            this.$nextTick(()=>{
                that.$refs['memberForm'].resetFields()
            })
            this.setVisible = true
        },
        // 选择施工队
        // teamHandle(val){
        //     let that = this
        //     if(!this.isNull(val)){
        //         let obj = {};
        //         obj = this.teamList.find((item)=>{
        //             return item.GdteamId === val;
        //         });
        //         // console.log('hh',val)
        //         this.memberQuery.userTeamNum = obj.StrConstrteamCode
        //         this.memberQuery.userTeamid = obj.GdteamId
        //     }else{
        //         this.memberQuery.userTeamNum = ''
        //         this.memberQuery.userTeamid = ''
        //     }
        //     // console.log('11',obj)
        // },
        // 获取列表
        getList(){
            this.tableLoading = true
            this.isSearchHandle = true
            xz.getTeamUserList(this.listQuery).then(res => {
            //   console.log('getList', res)
              if (res.status == 'ok') {
                  this.tableData = res.msg
                  this.total = res.totalcount
                }else{
                  this.tableData = []
                  this.total = 0
                }
              this.tableLoading = false
              this.isSearchHandle = false
              this.$store.commit("setSupComTabsIsover", true);
            })
        },
        //分页
        handleCurrentChange(val){
            this.listQuery.currpage = Number(val)
            this.getList()
        },
        handleSizeChange(val) {
            this.listQuery.currpage = 1
            this.listQuery.perpage = Number(val)
            this.getList()
        },
        calDaysBetween(date) {
            let startDate = Date.parse(date);
            let endDate = Date.parse(new Date());
            let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
            days > 7 ? this.isDownFeeTemplate = false : this.isDownFeeTemplate = true;
        },
        // 获取施工队列表
        getTeamList(){
            xz.getConstrTeamLists(this.teamQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                  this.teamList = res.msg
                }else{
                  this.teamList = []
                }
            })
        },
        // 搜索
        searchHandle(){
            this.listQuery.currpage = 1
            this.getList()
        },
        // 清空
        resetHandle(){
          this.listQuery = this.$options.data.call(this).listQuery
        },
        //筛选下拉
        dropDownScreen() {
            if (this.showDropScreen == -1) {
            this.showDropScreen = 1;
            } else if (this.showDropScreen == 1) {
            this.showDropScreen = -1;
            }
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
        }
    }
  }
</script>

<style scoped>
.p_clue_box{
    background-color: #fff;
}
.r_act_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  justify-content: flex-end;
  padding: 15px 15px;
}
.r_act_left{
  display: flex;
  align-items: center;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.main-con {
    background-color: #f3f3f3;
    padding: 0px 15px 15px;
    overflow-x: hidden;
    overflow-y: auto;
}
.r_dropDownScreen{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
}
.re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
}
.com_dialog_btn.el-button{
  background-color: #ebfaf5;
  border: 1px solid #62d2b4;
  color: #19BD92;
  font-weight: bold;
}
.com_dialog_btn.el-button:hover{
  background-color: #19BD92;
  border: 1px solid #62d2b4;
  color: #fff;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}
.steps-box {
  margin-top: 20px;
}
.steps-box .el-step__title {
  font-size: 14px;
  color: #999;
}
.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-box {
  position: relative;
}
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: absolute;
    top: 5px;
    right: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style>
.p_supply_module .el-form-item__label{
  padding: 0 5px 0 0;
}
.p_supply_module .el-tabs{
    background-color: #fff;
    padding: 0 10px;
}
.p_supply_module .screenInputs .screenInput {
  margin: 0 0 10px 5px;
}
.p_supply_module .screenInputs .screenInput .el-select .el-input__inner,
.p_supply_module .re_down_form.el-form--inline .el-form-item__content,
.p_supply_module .re_down_form .el-select,
.p_supply_module .re_down_form .el-form-item__content,
.p_supply_module .screenInput .el-input{
  width: 200px;
}
.re_table.el-table .cell{
padding: 0 5px;
}
.re_table.el-table .el-table__cell{
padding: 3px 0;
}
</style>